module.exports = __webpack_public_path__ + "img/pic_recharge_right2.57fbb626.png";